import { FC } from 'react';
import { DataSource, Gallery, Item, useGallery } from 'react-photoswipe-gallery';
import { Button, ImageList, ImageListItem } from '@mui/material';
import { ArrowRightAlt } from '@mui/icons-material';

const UniversityGalleryContent: FC<{ data: DataSource }> = ({ data }) => {
  const { open } = useGallery();

  return (
    <>
      <ImageList
        gap={3}
        cols={3}
        sx={{
          m: 0,
          backgroundColor: 'common.black',
          borderTop: '3px solid #000',
          borderBottom: '3px solid #000',
        }}
      >
        {data.slice(0, 6).map((img, idx) => {
          const cols = idx === 0 ? 2 : 1;
          const rows = idx === 0 ? 2 : 1;

          return (
            <Item
              sourceId={img.sourceId}
            >
              {({ ref, open }) => (
                <ImageListItem key={img.sourceId} cols={cols} rows={rows}>
                  <img
                    src={img.original}
                    ref={ref}
                    onClick={open}
                    alt={`Gallery #${img.sourceId}`}
                  />
                </ImageListItem>
              )}
            </Item>
          );
        })}
      </ImageList>
      {data.length > 6 && (
        <Button
          fullWidth
          variant="text"
          size="large"
          endIcon={<ArrowRightAlt/>}
          sx={{ justifyContent: 'left' }}
          color="inherit"
          onClick={() => open(1)}
        >
          View all
        </Button>
      )}
    </>
  );
};

export const UniversityGallery: FC<{ data: DataSource }> = ({ data }) => (
  <Gallery dataSource={data}>
    <UniversityGalleryContent data={data} />
  </Gallery>
);
